/**
 * Requests notification permissions from the user.
 *
 * @returns {Promise<boolean>} A promise that resolves to `true` if the user grants notification permissions,
 * or `false` otherwise.
 */
export const requestNotificationPermissions = async () => {
  // Check if the Notification API is supported by the browser
  if (!('Notification' in window)) {
    return false;
  } else if (Notification.permission === 'granted') {
    return true;
  } else if (Notification.permission !== 'denied') {
    // We need to ask the user for permission
    const permission = await Notification.requestPermission();
    return permission === 'granted';
  }
  return false;
};
